import reduce from 'lodash/reduce';
import entity from './entity';
import {
  merge,
  mergeDeep,
} from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import { TYPES } from './actions';

const coreReducer = entity.getReducer();

const reducer = (state = ReduxRestEntity.initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_ALL_COMPACT_REQUEST:
    case TYPES.GET_ALL_COMPACT_BY_EMAIL_REQUEST:
    case TYPES.UPDATE_PROFILE_REQUEST:
    case TYPES.GET_LOCATION_REQUEST:
    case TYPES.GET_PROFILE_JOBS_BY_COMPANY_NAME_REQUEST:
      return merge(state, {
        error: null,
        isLoading: true,
      });
    // If the profile exists within the redux state, we only want to overwrite the values of that profile with non-null
    // values returned from the api call. This prevents a compact profile view with limited data from overwriting
    // a more full profile object.
    case TYPES.SET_ENTITIES:
    case TYPES.UPDATE_PROFILE_REQUEST_SUCCESS:
    case TYPES.GET_ALL_COMPACT_REQUEST_SUCCESS:
    case TYPES.GET_ALL_COMPACT_BY_EMAIL_REQUEST_SUCCESS: {
      const reducedData = reduce(action.payload, (results, value, key) => {
        if (state.data[key]) {
          const noneNullReducedProfile = Object.entries(value)
            .reduce((innerResults, [k, v]) => (v == null ? innerResults : { ...innerResults, [k]: v }), {});
          return { ...results, [key]: { ...state.data[key], ...noneNullReducedProfile } };
        }
        return { ...results, [key]: { ...value } };
      }, state.data);
      return merge(state, {
        data: merge(state.data, reducedData),
        isLoading: false,
      });
    }
    case TYPES.GET_LOCATION_REQUEST_SUCCESS:
    case TYPES.GET_PROFILE_JOBS_BY_COMPANY_NAME_SUCCESS:
      return merge(state, {
        data: mergeDeep(state.data, action.payload),
        isLoading: false,
      });
    case TYPES.UPDATE_PROFILE_REQUEST_ERROR:
    case TYPES.GET_ALL_COMPACT_REQUEST_ERROR:
    case TYPES.GET_ALL_COMPACT_BY_EMAIL_REQUEST_ERROR:
    case TYPES.GET_LOCATION_REQUEST_ERROR:
    case TYPES.GET_PROFILE_JOBS_BY_COMPANY_NAME_ERROR:
      return merge(state, {
        error: action.payload,
        isLoading: false,
      });
    case TYPES.ADD_PROFILES:
      return merge(state, {
        data: {
          ...state.data,
          ...action.payload,
        },
      });
    case TYPES.UPDATE_REQUEST_SUCCESS:
      return mergeDeep(state, {
        data: action.payload,
        isLoading: false,
        error: null,
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
